import { Contact } from '@bumble/app/__generated__/data-contracts';
import NoData from '@bumble/app/components/NoData';
import { Box } from '@mui/material';
import DataTableGrid from '@bumble/app/components/DataTableGrid';
import { GridColDef } from '@mui/x-data-grid';
import { DateTime } from 'luxon';

const columns: GridColDef[] = [
  {
    field: 'first_name',
    headerName: 'First name',
    width: 200,
    disableColumnMenu: true,
  },
  {
    field: 'last_name',
    headerName: 'Last name',
    width: 200,
    disableColumnMenu: true,
  },
  {
    field: 'email',
    headerName: 'email',
    width: 200,
    disableColumnMenu: true,
  },
  {
    field: 'phone',
    headerName: 'Phone',
    width: 200,
    disableColumnMenu: true,
  },
  {
    field: 'contact_type',
    headerName: 'Type',
    flex: 1,
    minWidth: 300,
    disableColumnMenu: true,
  },
  {
    field: 'entity_name',
    headerName: 'Entity Name',
    width: 200,
    disableColumnMenu: true,
  },
  {
    field: 'created_at',
    headerName: 'Created at',
    minWidth: 150,
    disableColumnMenu: true,
    valueGetter: (params) => {
      if (params.value === null) return '';
      return DateTime.fromISO(params.value).toLocaleString(DateTime.DATETIME_SHORT);
    },
  },
//  {
//    field: 'updated_at',
//    headerName: 'Updated at',
//    minWidth: 150,
//    headerAlign: 'right',
//    align: 'right',
//    disableColumnMenu: true,
//    valueGetter: (params) => {
//      if (params.value === null) return '';
//      return DateTime.fromISO(params.value).toLocaleString(DateTime.DATETIME_SHORT);
//    },
//  },
];

const columnVisible = {
  first_name: true,
  last_name: true,
  email: true,
  phone: true,
  contact_type: true,
  entity_name: true,
  created_at: true,
  updated_at: false,
};

interface EntityDetailsProps {
  data: Contact[];
  refetchData: () => void
}

export const EntityDetails = ({ data, refetchData }: EntityDetailsProps) => {
  if (data === undefined) return <NoData />;

  return (
    <Box>
      <DataTableGrid
        rows={data.map((r, i) => ({ ...r, id: r.contact_id }))}
        columns={columns}
        columnVisibilityModel={columnVisible}
        refreshData={refetchData}
      />
    </Box>
  );
};
